/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';
import 'mailcheck';

function checkEmailInputElement(inputEl) {
  $(inputEl).mailcheck({
    suggested(element, suggestion) {
      $(element).parent().find('.email-suggestion').remove();

      const $suggestion = $('<span class="email-suggestion"/>');

      $('<span class="email-suggestion__caption"/>')
          .text('Did you mean').appendTo($suggestion);

      const $email = $('<a class="email-suggestion__email" href="javascript:;"/>')
          .text(suggestion.full).appendTo($suggestion);

      $email.on('click', (anchorEv) => {
        anchorEv.preventDefault();
        element.val(suggestion.full);
        checkEmailInputElement(inputEl);
      });

      $suggestion.append('?').insertAfter(element);
    },
    empty(element) {
      $(element).parent().find('.email-suggestion').remove();
    },
  });
}

$(document).on('blur', 'input.email-input', (ev) => {
  checkEmailInputElement(ev.currentTarget);
});

